<template>
  <section class="community"
           :class="deviceInfo.isInApp ? '':'paddingNoBottom'">
    <img src="https://cdn.gelonghui.com/webActive/img_community_content.png"
         alt />
    <div class="container">
      <img src="https://cdn.gelonghui.com/webActive/img_community_wechatbg.png"
           alt />
      <p v-clipboard="'GuruClub_88'"
         @success="onCopy"
         @error="onError"
         class="wechatAdd">GuruClub_88</p>
    </div>

    <button @click="shareto"
            v-if="deviceInfo.isInApp">
      <img src="https://cdn.gelonghui.com/webActive/img_button_download.png"
           alt />分享给好友
    </button>
  </section>
</template>

<script>
// import axios from "axios"
export default {
  name: "community",
  data() {
    return {
      deviceInfo: {
        userAgent: "",
        isInApp: false
      }
    };
  },
  created() {
    this.checkDeviceInfo();
  },
  mounted() {
    document.title = "会员社群";
  },
  methods: {
    onCopy: function (e) {
      this.$toast("复制成功~");
    },
    onError: function (e) {
      this.$toast("复制失败~");
    },
    shareto() {
      //---------------------分享
      console.log("我点了分享");
      let title = "格隆汇会员专享社群";
      let summary = "和格隆汇研究团队一起交流投资经验";
      let url =
        window.location.origin + window.location.pathname + "#/shareCommunity";
      let image = "https://cdn.gelonghui.com/webActive/wechat_shequn.png";
      let shareType = "article";
      if (this.deviceInfo.isInApp) {
        if (this.deviceInfo.userAgent === "iOS") {
          let pass_data = {
            title: title,
            content: summary,
            url: url,
            image: image
          };
          pass_data = JSON.stringify(pass_data);
          try {
            window.webkit.messageHandlers.iosPresentSharePage.postMessage(
              pass_data
            );
          } catch (err) {
            console.log(err);
          }
        } else {
          try {
            window.NativeInterface.share(title, summary, url, image, shareType);
          } catch (e) {
            console.log(e);
          }
        }
      } else {
        window.location.href =
          "https://www.gelonghui.com/app/device_redirect.html";
      }
    },
    checkDeviceInfo() {
      //----------------------------判断设备
      if (
        (window.NativeInterface && window.NativeInterface.isLogined) ||
        (window.webkit &&
          window.webkit.messageHandlers &&
          window.webkit.messageHandlers.iosCheckIsLoggedIn)
      ) {
        this.deviceInfo.isInApp = true;
      } else {
        this.deviceInfo.isInApp = false;
      }
      let ua = navigator.userAgent.toLowerCase();
      //判断设备
      if (this.deviceInfo.isInApp) {
        if (/iphone|ipad|ipod/.test(ua)) {
          // 在ios里
          this.deviceInfo.userAgent = "iOS";
          // this.getIntroduction();
        } else if (/android/.test(ua)) {
          this.deviceInfo.userAgent = "android";
        }
      } else {
        // window.location.href =
        //   "https://www.gelonghui.com/app/device_redirect.html";
      }
    }
  }
};
</script>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  box-sizing: border-box;
}

.community {
  position: relative;
  max-width: 750px;
  padding-bottom: 82px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  &.paddingNoBottom {
    padding-bottom: 0;
  }

  > img {
    width: 100%;
  }
  .container {
    width: 100%;
    position: absolute;
    top: 330px;
    left: 50%;
    transform: translateX(-50%);
    img {
      width: 100%;
    }
    .wechatAdd {
      position: absolute;
      top: 74px;
      left: 260px;
      font-size: 34px;
      color: rgba(115, 81, 36, 1);
      font-weight: 600;
    }
  }
  > button {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 88px;
    border: none;
    outline: none;
    text-align: center;
    background: rgba(255, 224, 170, 1);
    font-size: 30px;
    font-weight: 600;
    color: rgba(120, 72, 47, 1);
    line-height: 88px;
    max-width: 750px;
    margin: auto;

    img {
      vertical-align: middle;
      width: 40px;
      margin-top: -4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/member-share/community.vue